<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('help.titleIn')" prop="titleIn" >
        <a-input v-model="form.titleIn" :placeholder="$t('help.inputTitleIn')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('help.titleEn')" prop="titleEn" >
        <a-input v-model="form.titleEn" :placeholder="$t('help.inputTitleEn')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('help.titleCn')" prop="titleCn" >
        <a-input v-model="form.titleCn" :placeholder="$t('help.inputTitleCn')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('help.title')" prop="title" >
        <a-input v-model="form.title" :placeholder="$t('help.inputTitleIn')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('help.contentIn')" prop="contentIn" >
        <editor editorValue="contentIn" v-model="form.contentIn" />
      </a-form-model-item>
      <a-form-model-item :label="$t('help.contentEn')" prop="contentEn" >
        <editor editorValue="contentEn" v-model="form.contentEn" />
      </a-form-model-item>
      <a-form-model-item :label="$t('help.contentCn')" prop="contentCn" >
        <editor editorValue="contentCn" v-model="form.contentCn" />
      </a-form-model-item>
      <a-form-model-item :label="$t('help.content')" prop="content" >
        <editor editorValue="content" v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item :label="$t('help.sort')" prop="sort" >
        <a-input-number v-model="form.sort" :placeholder="$t('help.inputSort')" />
      </a-form-model-item>
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getHelp, addHelp, updateHelp } from '@/api/help/help'
import Editor from '@/components/Editor'
export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor,
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        title: null,
        titleEn: null,
        titleCn: null,
        titleIn: null,
        content: null,
        contentEn: null,
        contentCn: null,
        contentIn: null,
        sort: null,
        createTime: null,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    rules() {
      return {
        titleIn: [
          { required: true, message: this.$t('help.titleRequired') }
        ],
        sort: [
          { required: true, message: this.$t('help.sortRequired') }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {

      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.$nextTick(() => {
        this.form = {
          id: null,
          title: null,
          titleEn: null,
          titleCn: null,
          titleIn: null,
          content: null,
          contentEn: null,
          contentCn: null,
          contentIn: null,
          sort: null,
          createTime: null,
          remark: null
        }
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('help.add')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getHelp({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('help.edit')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateHelp(this.form).then(response => {
              this.$message.success(
                this.$t('system.updateSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addHelp(this.form).then(response => {
              this.$message.success(
                this.$t('system.addSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
